/** Returns true if event is not sold out and there is at least one listing */
export const checkHasListings = (params: {
  isSoldOut: boolean;
  listingQty: number;
}): boolean => {
  const { isSoldOut, listingQty } = params;
  return !isSoldOut && !!listingQty;
};
